export const REQUEST_TYPE_OPTIONS = [
  { value: "flightSchedule",            label: "Flight Schedule" },
  { value: "crewSchedule",              label: "Crew Schedule" },
  { value: "crewRosterDetails",         label: "Crew Roster Details" },
  { value: "jumpSeaters",               label: "Jump Seaters" },
  { value: "flightScheduleChanges",     label: "Flight Schedule Changes" },
  { value: "crewScheduleChanges",       label: "Crew Schedule Changes" },
  { value: "unfinalizedCrewRoutes",     label: "Unfinalized Crew Routes" },
  { value: "crewPendingNotifications",  label: "Crew Pending Notifications" },
  { value: "crewMaxFDP",                label: "Crew Max FDP" },
  { value: "crewList",                  label: "Crew List" },
  { value: "crewQuals",                 label: "Crew Qualifications" },
  { value: "aircraftSchedule",          label: "Aircraft Schedule" },
];

export const STATUS_OPTIONS = ["Pending", "Processing", "Done", "Failed"];

export const STATUS_COLOR = {
  Pending:    "warning",
  Processing: "info",
  Done:       "success",
  Failed:     "error",
};
